import StarEmpty from '@petplate/icons/core/StarEmpty';
import StarFull from '@petplate/icons/core/StarFull';
import lens from '@refract-ui/sc/lens';
import React from 'react';
import { css } from 'styled-components';

interface Props {
  score?: number;
}

const StarWrapper = lens.div()`
  ${({ theme: { mq } }) => css`
    display: flex;

    svg {
      width: 16px;
      height: 16px;
    }

    ${mq.md`
      svg {
        width: 24px;
        height: 24px;
      }
    `}
  `}
`;

const CurrentStars = lens.div()<{ $score: number }>`
  ${({ $score }) => css`
    overflow: hidden;
    width: ${($score * 100) / 5}%;
    white-space: nowrap;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  `}
`;

const EmptyStars = lens.div()`
  position: absolute;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
`;

const MAX_STARS = 5;

export const Stars: React.FC<Props> = ({ score = 0 }) => {
  return (
    <StarWrapper>
      <CurrentStars $score={score}>
        {[...Array(MAX_STARS)].map((_s, idx) => (
          <StarFull key={idx} color="#0068E1" />
        ))}
      </CurrentStars>
      <EmptyStars>
        {[...Array(MAX_STARS)].map((_s, idx) => (
          <StarEmpty key={idx} color="#E0E3E0" />
        ))}
      </EmptyStars>
    </StarWrapper>
  );
};

export default Stars;
